import { render, staticRenderFns } from "./routeRepeat.component.vue?vue&type=template&id=8196513a&scoped=true&"
import script from "./routeRepeat.component.vue?vue&type=script&lang=js&"
export * from "./routeRepeat.component.vue?vue&type=script&lang=js&"
import style0 from "./routeRepeat.component.vue?vue&type=style&index=0&id=8196513a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8196513a",
  null
  
)

export default component.exports